import * as types from '../mutation-types'
import api from '@/api/company'

// initial state
const state = {
  publicCompanies: [],
  publicCompany: null,
  loaded: false,
  publicCompanyloaded: false,
}

const getters = {
  publicCompanies: (state, getters) => {
    let ids = getters.userCompanies.map(company => company.idCompany)
    return state.publicCompanies.filter(company => {
      return !ids.includes(company.idCompany)
    })
  },
  publicCompany: state => state.publicCompany,
  publicCompaniesLoaded: state => state.loaded,
}

const actions = {
  getPublicCompanies({ commit }, payload) {
    commit(types.SET_PUBLIC_COMAPNIES_LOADED, false );
    api.getPublicCompanies(payload,(response) => {
      commit(types.SET_PUBLIC_COMAPNIES, response._embedded.Company );
      commit(types.SET_PUBLIC_COMAPNIES_LOADED, true );
    })
  },
  getPublicCompany({ commit }, {query, cb}) {
    commit(types.SET_PUBLIC_COMAPNY_LOADED, true );
    api.getPublicCompany(query,(response) => {
      commit(types.SET_PUBLIC_COMAPNY, response );
      commit(types.SET_PUBLIC_COMAPNY_LOADED, true );
      cb();
    })
  },
}

const mutations = {
  [types.SET_PUBLIC_COMAPNIES] (state, publicCompanies ) {
    state.publicCompanies = publicCompanies
  },
  [types.SET_PUBLIC_COMAPNIES_LOADED] (state, status ) {
    state.loaded = status
  },
  [types.SET_PUBLIC_COMAPNY] (state, data ) {
    state.publicCompany = data
  },
  [types.SET_PUBLIC_COMAPNY_LOADED] (state, status ) {
    state.publicCompanyloaded = status
  },
}


export default {
  state,
  getters,
  actions,
  mutations
}


